import { v4 as uuid } from 'uuid';
export var OrderChangeType;
(function (OrderChangeType) {
    OrderChangeType["billingAddressChanged"] = "billingAddressChanged";
    OrderChangeType["deliveryAddressChanged"] = "billingAddressChanged";
    OrderChangeType["itemsAdded"] = "itemsAdded";
    OrderChangeType["itemsChanged"] = "itemsChanged";
    OrderChangeType["itemsRemoved"] = "itemsRemoved";
})(OrderChangeType || (OrderChangeType = {}));
export class OrderChange {
    id;
    orderId = null;
    type = null;
    requiresAccounting = false;
    description = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyToUse = key;
                let keyIsDefinedOnInstance = definedKeys.includes(keyToUse);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [keyToUse]: value });
                }
            }
        }
    }
}
export class OrderHistoryItem {
    id;
    companyId = null;
    orderId = null;
    date = null;
    changes = [];
    requiresAccounting = false;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyToUse = key;
                let keyIsDefinedOnInstance = definedKeys.includes(keyToUse);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [keyToUse]: value });
                }
            }
        }
    }
    static createFromOrders(oldValue, newValue) {
        if (!oldValue || !newValue || oldValue.id != newValue.id) {
            console.log("OrderHistoryItem:createFromOrders: Invalid Orders", oldValue, newValue);
            throw new Error("OrderHistoryItem:createFromOrders: Invalid Orders");
        }
        let historyItem = new OrderHistoryItem(uuid());
        historyItem.orderId = oldValue.id;
        historyItem.companyId = oldValue.companyId;
        historyItem.date = new Date();
        function compareItems(a, b) {
            let changes = { somethingChanged: false, quantityChanged: false, addonsChanged: false, chosenChanged: false, optionsChanged: false, changesNeedAccounting: false };
            if (a.quantity != b.quantity) {
                changes.quantityChanged = true;
                changes.changesNeedAccounting = true;
                changes.somethingChanged = true;
            }
            if (a.addons && a.addons.length > 0) {
                for (let addon of a.addons) {
                    // console.log('no freshAddon', addon.id)
                    let freshAddon = null;
                    if (!b.addons || b.addons.length > 0) {
                        freshAddon = b.addons.find((el) => addon.id == el.id);
                    }
                    if (!freshAddon) {
                        changes.addonsChanged = true;
                        changes.somethingChanged = true;
                        //if a paid addon got removed it needs accounting
                        if (addon.price) {
                            changes.changesNeedAccounting = true;
                        }
                    }
                    else {
                        if (addon.price != freshAddon.price) {
                            throw new Error('prices-changed');
                        }
                    }
                }
            }
            //check if there are any newly added addons
            if (b.addons && b.addons.length > 0) {
                for (let addon of b.addons) {
                    let oldAddon = null;
                    if (!a.addons || a.addons.length > 0) {
                        oldAddon = a.addons.find((el) => addon.id == el.id);
                    }
                    if (!oldAddon) {
                        changes.somethingChanged = true;
                        changes.addonsChanged = true;
                        //if its a paid addon it needs accounting
                        if (addon.price) {
                            changes.changesNeedAccounting = true;
                        }
                    }
                }
            }
            return changes;
        }
        //check addresses
        let billingAddressChanged = JSON.stringify(oldValue.billingAddress) != JSON.stringify(newValue.billingAddress);
        if (billingAddressChanged) {
            historyItem.changes.push(new OrderChange(uuid(), { orderId: oldValue.id, type: OrderChangeType.billingAddressChanged, requiresAccounting: true }));
        }
        let deliveryAddressChanged = JSON.stringify(oldValue.deliveryAddress) != JSON.stringify(newValue.deliveryAddress);
        if (deliveryAddressChanged) {
            historyItem.changes.push(new OrderChange(uuid(), { orderId: oldValue.id, type: OrderChangeType.deliveryAddressChanged, requiresAccounting: true }));
        }
        //check if the existing items changed or got deleted
        for (let item of oldValue.orderItems) {
            let freshItem = newValue.orderItems.find((el) => item.id == el.id);
            if (!freshItem) {
                historyItem.changes.push(new OrderChange(uuid(), { orderId: oldValue.id, type: OrderChangeType.itemsRemoved, requiresAccounting: true }));
                continue;
            }
            if (freshItem.basePrice != item.basePrice) {
                console.log('freshItem.basePrice != item.basePrice', freshItem.basePrice, item.basePrice);
                throw new Error('prices-changed');
            }
            let changes = compareItems(item, freshItem);
            if (changes.somethingChanged) {
                historyItem.changes.push(new OrderChange(uuid(), { orderId: oldValue.id, type: OrderChangeType.itemsChanged, requiresAccounting: changes.changesNeedAccounting }));
            }
        }
        // console.log('oldValues',oldValue.orderItems.map((el) => {
        //     return el.id
        // }))
        // console.log('newValues',newValue.orderItems.map((el) => {
        //     return el.id
        // }))
        //check if there are new items which arent in th old order
        for (let item of newValue.orderItems) {
            let oldItem = newValue.orderItems.find((el) => item.id == el.id);
            if (!oldItem) {
                historyItem.changes.push(new OrderChange(uuid(), { orderId: oldValue.id, type: OrderChangeType.itemsAdded, requiresAccounting: true }));
                continue;
            }
        }
        return historyItem;
    }
}
